import React from "react";
import { Crown } from "lucide-react"; // Importing the premium icon

//const PremiumIcon = () => {
//    return (
//        <div className="inline-flex items-center px-2 py-1 bg-gradient-to-r from-black to-gray-900 border border-yellow-500 rounded-full shadow-md text-xs">
//            <Crown className="text-yellow-500 w-4 h-4 mr-1" />
//            <span className="text-white font-medium">PREMIUM</span>
//        </div>
//    );
//};


const PremiumIcon = () => {
    return (
        <div className="inline-flex items-center px-2 py-1 bg-gradient-to-r from-yellow-600 to-yellow-400 border border-yellow-500 rounded-full shadow-md text-xs text-white font-semibold">
            <Crown className="text-white w-4 h-4 mr-0.5 drop-shadow-sm" />
        </div>
    );
};

export default PremiumIcon;
